import { createAsyncSelectors } from '@lib/selectors';
import { SETTINGS_ORGANIZATION_COPY } from '@sonar-software/sonar-ts-constants';
import { When } from 'react-if';
import { Button, Modal } from 'antd';
import { coreActions } from '@sonar-software/sonar-core';
import React, { useCallback, useEffect } from 'react';
import { useAction, useAppNotifications, useAsyncCollection, useCurrentOrganization, useCurrentUser, useSonarSelector } from '@hooks';
const organizationsSelectors = createAsyncSelectors((state) => state.core.organizations.all.get);
const unlinkOrganizationSelectors = createAsyncSelectors((state) => state.core.organizations.unlink.post);
export const DisconnectButton = ({ organization }) => {
    const { isReadOnly } = useCurrentUser();
    const { infoNotification } = useAppNotifications();
    const currentOrganization = useCurrentOrganization();
    const showDisconnectButton = !isReadOnly && (currentOrganization === null || currentOrganization === void 0 ? void 0 : currentOrganization.id) !== organization.id;
    const isUnlinkSuccessful = useSonarSelector(unlinkOrganizationSelectors.isReceived);
    const requestUnlink = useAction(coreActions.requestPostCoreOrganizationsUnlink);
    const resetUnlinkRequest = useAction(coreActions.resetPostCoreOrganizationsUnlink);
    const organizations = useAsyncCollection(organizationsSelectors.state);
    const organizationCount = organizations === null || organizations === void 0 ? void 0 : organizations.length;
    useEffect(() => {
        if (isUnlinkSuccessful) {
            resetUnlinkRequest();
        }
    }, [isUnlinkSuccessful, resetUnlinkRequest]);
    const handleRemoveOrganization = useCallback(() => {
        const { id, name } = organization;
        Modal.confirm({
            content: SETTINGS_ORGANIZATION_COPY.DISCONNECT_MESSAGE,
            okType: 'danger',
            onOk() {
                if (organizationCount > 1) {
                    requestUnlink({ organizationId: id });
                }
                else {
                    infoNotification(SETTINGS_ORGANIZATION_COPY.DISCONNECT_WARNING);
                }
            },
            title: SETTINGS_ORGANIZATION_COPY.DISCONNECT_TITLE(name)
        });
    }, [infoNotification, organization, organizationCount, requestUnlink]);
    return (React.createElement(When, { condition: showDisconnectButton },
        React.createElement(Button, { danger: true, onClick: () => {
                handleRemoveOrganization();
            }, type: 'text' }, SETTINGS_ORGANIZATION_COPY.DISCONNECT)));
};
